import { ca } from '@cian/analytics';

/**
 * @description Событие: пользователь изменил фильтр первоначального взноса в блоке ипотечных офферов.
 */
export const trackDownPaymentFilterChange = (): void => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: 'initial_fee',
    name: 'oldevent',
    useLastProducts: true,
  });
};
